import React from "react";
import { useTranslation } from "react-i18next";
import * as moment from "moment";
import styled from "styled-components";
import FeedbackModal from "../feedback/FeedbackModal";

const DatesCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.spacing.xs};
  padding: ${(p) => p.theme.spacing.md};
  background: ${(p) => p.theme.color.surfaceAlt};
  border-radius: ${(p) => p.theme.radius.sm};
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeSm};
  color: ${(p) => p.theme.color.textMuted};
  text-align: center;
`;

const BowlerInfoModal = ({
  show,
  onHide,
  onEdit,
  onDelete,
  isReadOnly,
  created_at,
  updated_at,
}) => {
  const { t } = useTranslation();

  const message = (
    <DatesCard>
      <span>
        {t("Created: ")}
        {moment(created_at).format("MM/DD/YYYY hh:mm:ss")}
      </span>
      <span>
        {t("Updated: ")}
        {moment(updated_at).format("MM/DD/YYYY hh:mm:ss")}
      </span>
    </DatesCard>
  );

  return (
    <FeedbackModal
      show={show}
      onHide={onHide}
      severity="neutral"
      title={t("bowlerInfoModal.title")}
      message={message}
      secondaryAction={{
        label: t("bowlerInfoModal.editBowler"),
        onClick: () => onEdit && onEdit(),
      }}
      primaryAction={
        isReadOnly
          ? null
          : {
              label: t("bowlerInfoModal.delete"),
              onClick: () => onDelete && onDelete(),
              variant: "danger",
            }
      }
    />
  );
};

export default BowlerInfoModal;
